import React, { useEffect, useState } from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import "./ProjectGallerySlider.css";

export default function ProjectGallerySlider({ images = [], title = "Project gallery", className = "" }) {
  const slides = Array.isArray(images) ? images.filter((image) => image?.src) : [];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [slides.length]);

  if (!slides.length) return null;

  const goTo = (index) => setActiveIndex(index);
  const previous = () => setActiveIndex((index) => (index === 0 ? slides.length - 1 : index - 1));
  const next = () => setActiveIndex((index) => (index === slides.length - 1 ? 0 : index + 1));
  const activeSlide = slides[activeIndex];

  return (
    <section className={`project-gallery-slider ${className}`.trim()} aria-label={title}>
      <div className="project-gallery-stage">
        <img src={activeSlide.src} alt={activeSlide.alt || title} className="project-gallery-image" loading="lazy" />

        {slides.length > 1 && (
          <>
            <button
              type="button"
              className="project-gallery-nav project-gallery-prev"
              onClick={previous}
              aria-label="Show previous project image"
            >
              <FaArrowLeftLong />
            </button>
            <button
              type="button"
              className="project-gallery-nav project-gallery-next"
              onClick={next}
              aria-label="Show next project image"
            >
              <FaArrowRightLong />
            </button>
          </>
        )}
      </div>

      {slides.length > 1 && (
        <div className="project-gallery-controls">
          <div className="project-gallery-dots" aria-label="Project image slides">
            {slides.map((image, index) => (
              <button
                key={image.src}
                type="button"
                className={index === activeIndex ? "active" : ""}
                onClick={() => goTo(index)}
                aria-label={`Show project image ${index + 1}`}
              />
            ))}
          </div>
          <p className="project-gallery-count">
            {activeIndex + 1} / {slides.length}
          </p>
        </div>
      )}
    </section>
  );
}
